export default __webpack_public_path__ + "static/media/rapidsense_vertical.86fa468f.svg";